import React, { useState, useEffect } from "react";
import '../../components/ThreeTab/ThreeTab/Settings.css';
import { CiEdit } from "react-icons/ci";
import { getSettingDetails } from "../../API/Api";
import { removeAuthToken } from "../../utils/auth";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SidebarTab from '.././SidebarTab/SidebarTab';
const Settings = () => {
  const [userData, setUserData] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getSettingDetails();
        setUserData(data.user);
      } catch (error) {
        console.error("Error fetching settings details:", error);
      }
    };

    fetchData();
  }, []);
  const getUserInitials = (firstName, lastName) => {
    let initials = '';
    if (firstName?.trim()) initials += firstName.trim()[0].toUpperCase();
    if (lastName?.trim()) initials += lastName.trim()[0].toUpperCase();
    return initials || 'U';
  };
  const handleLogout = () => {
    removeAuthToken();
    toast.success("You have been logged out successfully");
    // navigate("/");
    setTimeout(() => {
      window.location.href = "/"
    }, 1000);

  };

  if (!userData) {
    return <div>Loading...</div>;
  }
  return (
    <div className="verification-container">
      <SidebarTab />
      <div className="settings-container">
        <h2 className="settings-title">Settings</h2>
        <p className="profile-title">Profile</p>

        <div className="profile-section">
          <div className="profile-info">
            {userData?.image ? (
              <img src={userData.image} alt="User" className="user-avatar" />
            ) : (
              <div className="user-initials">
                {getUserInitials(userData?.first_name, userData?.last_name)}
              </div>
            )}
            <div>
              <h3>{userData.first_name} {userData.last_name}</h3>
              <p className="add">{userData.address}</p>
            </div>
          </div>
          <div className="edit-button-container">
            <button className="edit-button">
              Edit
              <CiEdit />
            </button>
          </div>
        </div>

        <div className="form-section-setting">
          <div className="form-field">
            <label>Name</label>
            <input type="text" value={userData.display_name} className="input-field-setting" readOnly />
          </div>

          <div className="email-section">
            <div className="email-fields-container">
              <div className="form-field">
                <label>Primary Email</label>
                <input type="email" value={userData.email} className="input-field-settings" readOnly />
                {/* <button className="edit-button2">Edit</button> */}
              </div>
              <div className="form-field">
                <label>Secondary Email</label>
                <input type="email" value={userData.secondary_email} className="input-field-settings" readOnly />
                {/* <button className="edit-button2">Edit</button> */}
              </div>
            </div>
          </div>

          <div className="email-section">
            <div className="email-fields-container">
              <div className="form-field">
                <label>Phone</label>
                <input type="text" value={userData.ph_number} className="input-field-settings" readOnly />
                {/* <button className="edit-button2">Edit</button> */}
              </div>
              <div className="form-field">
                <label>Current Password</label>
                <input type="email" placeholder="******" className="input-field-settings" />
                {/* <button className="edit-button2">Edit</button> */}
              </div>
            </div>
          </div>
        </div>
        <button className="logout-button-setting logoutBtn" onClick={handleLogout}>LOG OUT</button>
      </div>
    </div>

  );
};

export default Settings;